module.exports = __webpack_public_path__ + "media/src/images/partners/bundesministerium-082071efb11c014c427e634c99c1f04b.jpg";